<template>
    <div>
        <base-header class="pb-6"></base-header>
        <div class="container-fluid mt--6">
            <div class="card">
                <div class="card-header border-0">
                    <div class="row">
                        <div class="col-sm-8">
                        <h3 class="mb-0">{{ category.name }}</h3>
                        <h3 class="mb-0" >Estado: {{ category.status == 'done' ? 'Completo' : 'Pendiente' }}</h3>
                        </div>
                        <div class="col-sm-4">
                        <h3 class="mb-0">Observación: {{ category.observation }}</h3>
                        <h3 class="mb-0">{{ category.points }} PTS</h3>
                        </div>
                    </div>
                </div>
                <div class="row starter-page">
                    <div class="container-fluid">
                        <el-table
                        class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        row-key="id"
                        :data="faq"
                        >
                        <el-table-column label="Pregunta" prop="question"  min-width="200px" sortable>
                            <template v-slot="{row}">{{ row.question}}</template>
                        </el-table-column>
                        <el-table-column label="Respuesta" prop="score"  min-width="200px" sortable>
                            <template v-slot="{row}">{{ row.score == 'good' ? 'Bueno' : (row.score == 'bad') ? 'Malo' : 'Regular' }}</template>
                        </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Dropdown, DropdownItem, DropdownMenu, Table, TableColumn, Tooltip} from "element-ui";
import axios from "axios";
export default {
    name: "FAQ",
    components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    },
    data() {
        return {
        faq: [],
        category: ''
        };
    },
    created() {
    this.getCategory()
    },
    methods: {
        getCategory(){
            axios.get(`/evaluacion/category/${this.$route.params.faq}`).then((response => {
                this.category = response.data
                this.faq = this.category.faqs
            }))
        },
    },
}
</script>
<style lang="scss" scoped>

</style>